import { render, staticRenderFns } from "./SurveyQuestion.vue?vue&type=template&id=4ad188dd&scoped=true"
import script from "./SurveyQuestion.vue?vue&type=script&lang=ts"
export * from "./SurveyQuestion.vue?vue&type=script&lang=ts"
import style0 from "./SurveyQuestion.vue?vue&type=style&index=0&id=4ad188dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad188dd",
  null
  
)

export default component.exports